import axios from 'axios';

export default {
  async applyDiscount({ commit, dispatch, rootState }, args) {
    const payload = {
      code: args.code
    };

    if (args.delete) {
      payload.delete = args.delete;
    }

    console.log('applyDiscount', payload);

    const config = {
      params: {
        action: 'apply_discount',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);

    await dispatch('getPaymentMethods', payload);
  },
  async getCountriesWithStates({ commit }) {
    const { data } = await axios.get(
      '/Umbraco/Api/Countries/CountriesWithStates'
    );
    commit('setCountriesWithStates', data);
  },
  async getPaymentMethods({ commit, dispatch, rootState }) {
    const payload = {};

    const config = {
      params: {
        action: 'get_payment_methods',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setPaymentMethods', data);

    // Wanneer een voucher is verzilverd en er geen betaalmethode wordt getoond
    // dan wordt de betaalmethode 'zero_value' automatisch geselecteerd.
    if (
      data &&
      data.payment_methods &&
      data.payment_methods.length > 0 &&
      data.payment_methods[0].id === 'zero_value'
    ) {
      await dispatch('setPaymentMethod', { id: 'zero_value' });
    }
  },
  async getServicePartners({ commit, rootState }) {
    const payload = {};

    const config = {
      params: {
        action: 'get_sps',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setServicePartners', data);
  },
  async getShippingAddresses({ commit, rootState }) {
    const payload = {};

    const config = {
      params: {
        action: 'get_shipping_addresses',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShippingAddresses', data);
  },
  async getTransportMethods({ commit, rootState }) {
    const payload = {};

    const config = {
      params: {
        action: 'get_transport_methods',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setTransportMethods', data);
  },
  async requestQuote({ commit, rootState }) {
    const payload = {};

    console.log('requestQuote', payload);

    const config = {
      params: {
        action: 'request_quote',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async setAdditionalInfo(
    { commit, rootState },
    { attachments, comment, inquiryOrOrderNumber, reference }
  ) {
    const payload = {
      attachments,
      comment,
      inquiry_or_order_number: inquiryOrOrderNumber,
      reference
    };

    console.log('setAdditionalInfo', payload);

    const config = {
      params: {
        action: 'set_additional_info',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async setPaymentMethod({ commit, rootState }, { id }) {
    const payload = {
      id
    };

    console.log('setPaymentMethod', payload);

    const config = {
      params: {
        action: 'set_payment_method',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async setServicePartner({ commit, rootState }, { companyNumber }) {
    const payload = {
      company_number: companyNumber
    };

    console.log('setServicePartner', payload);

    const config = {
      params: {
        action: 'set_sp',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async setShippingAddress({ commit, rootState }, address) {
    const payload = {};

    if (address.id) payload.address_id = address.id;
    if (address.companyName) payload.company_name = address.companyName;
    if (address.addressLine1) payload.address_line_1 = address.addressLine1;
    if (address.addressLine2) payload.address_line_2 = address.addressLine2;
    if (address.zipCode) payload.zip_code = address.zipCode;
    if (address.city) payload.city = address.city;
    if (address.countryCode) payload.country_code = address.countryCode;
    if (address.state) payload.state = address.state;
    if (address.isCustomerAddress !== undefined)
      payload.is_customer_address = address.isCustomerAddress;

    console.log('setShippingAddress', payload);

    const config = {
      params: {
        action: 'set_shipping_address',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async setTransportMethod({ commit, rootState }, { id }) {
    const payload = {
      id
    };

    console.log('setTransportMethod', payload);

    const config = {
      params: {
        action: 'set_transport_method',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async startCheckout({ commit, rootState }, { checkoutType }) {
    const payload = {
      checkout_type: checkoutType
    };

    console.log('startCheckout', payload);

    const config = {
      params: {
        action: 'start_checkout',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);
    commit('setShoppingCart', data);
    commit('setCheckoutData', data);
  },
  async startPayment({ commit, rootState }) {
    const payload = {
      success_redirect_url: rootState.webshop.paymentSuccessURL,
      failed_redirect_url: window.location.href // just return to checkout page upon canceled / failed payment
    };

    console.log('startPayment', payload);

    const config = {
      params: {
        action: 'start_payment',
        culture: rootState.culture
      }
    };

    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);

    commit('resetShoppingCart');

    console.log('startPayment result, before redirect', data);

    window.location.href = data.PaymentUrl;
  },
  async submitAttachments({ dispatch, state }) {
    if (state.checkoutAttachments.length) {
      const { data } = await axios.post('/Umbraco/Api/WilaMedia/Upload', {
        files: state.checkoutAttachments
      });

      const attachments = data.files.map((x) => ({
        file_name: x.fileName,
        path: x.path
      }));

      const payload = {
        attachments,
        comment: state.shoppingCart.additionalInfo.comment,
        inquiryOrOrderNumber:
          state.shoppingCart.additionalInfo.inquiryOrOrderNumber,
        reference: state.shoppingCart.additionalInfo.reference
      };
      await dispatch('setAdditionalInfo', payload);
    }
  }
};
